import React, {useEffect} from 'react'
import {Helmet} from 'react-helmet-async'
import {CopyInput} from '../../../components/library/copy'
import {Icon} from '../../../components/library/icon/icon'
import {EnvironmentNode} from '../../../environment'
import {useAnalytics} from '../../../lib/analytics/analytics'
import {getApiUrl} from '../../../lib/endpoints'
import {CUSTOMER_API_URL} from '../../../lib/env'
import {IconHeading, Section, SectionInfo} from '../components'

export const APIEndpoint = ({environment}: {environment: EnvironmentNode}) => {
  const analytics = useAnalytics()

  useEffect(() => {
    analytics.track({
      event: 'Viewed api base url endpoint configuration',
      properties: {
        org_id: environment.organisationId,
        environment_id: environment.id,
        category: 'configuration>api>base-url-endpoint'
      }
    })
  }, [analytics, environment])

  return (
    <Section>
      <Helmet>
        <title>Base URL Endpoint</title>
      </Helmet>
      <header>
        <IconHeading>
          <Icon name="web" /> Base URL Endpoint
        </IconHeading>
      </header>
      <SectionInfo>
        <p>
          The base URL for interacting with this Environment via the Atomic API
        </p>
      </SectionInfo>
      <CopyInput
        size="large"
        value={`${getApiUrl(CUSTOMER_API_URL)(
          environment?.organisationId || ''
        )}/v1/${environment.id}`}
      />
    </Section>
  )
}
